import { defineComponent, renderSlot } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormWrapperContext",
  props: {
    formSlotProps: {}
  },
  setup(__props, { expose: __expose }) {
    return __expose({ context: __props.formSlotProps }), (_ctx, _cache) => renderSlot(_ctx.$slots, "default");
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormWrapperContext.js.map
